module.exports = __webpack_public_path__ + "static/media/pin-alt.20c3ee12.svg";